<template>
  <div class="header">
    <div class="common-header">
      <div class="common-header-inner" :style="commonHeaderImg">
        <div class="common-header-top">PLncDB</div>
        <div class="common-header-common">
          <span>PLncDB contains
            <b class="numClass">{{ lncRNAs }}</b> lncRNAs</span>
          <span>
            and
            <b class="numClass">{{expression}}</b> RNA-Seq datasets for
            <b class="numClass">{{ species }}</b> species</span>
        </div>
      </div>
    </div>
    <v-navbar></v-navbar>
  </div>
</template>
<script>
import bus from "../common/bus";
import vNavbar from "./Navbar.vue";

export default {
  data() {
    return {
      species: 0,
      lncRNAs: 0,
      // Genes: "55669",
      expression: 0,
      commonHeaderImg: {
        "background-image":
          "url(" + require("@/assets/img/homePageHeader.png") + ")"
      }
    };
  },
  components: {
    vNavbar
  },
  mounted() {
    this.getTopData()
  },
  methods: {
    getTopData() {
      this.$axios.get("species/specie_count").then(res => {
        if (res.data.code == 200) {
          this.lncRNAs = res.data.data[0].lncRNAs
          this.expression = res.data.data[0].expression
          this.species = res.data.data[0].species
          sessionStorage.removeItem("specie_count");
          sessionStorage.setItem("specie_count", JSON.stringify(res.data.data[0]));
        }
      }).catch((error) => {
      });
    }
  }
};
</script>
<style scoped>
.header {
  margin: 0;
  padding: 0;
  position: relative;
  top: 0;
  box-sizing: border-box;
  width: 100%;
  background: #87d5ee;
}
.header .common-header {
  margin: 0 auto;
  /* background-size: 1940px, 413px; */
}
.header .common-header .common-header-inner {
  margin: 0 auto;
  width: 1240px;
  height: 250px;
  background-position: 100% 10px;
  background-repeat: no-repeat;
}
.header .common-header .common-header-top {
  padding-top: 35px;
  padding-left: 70px;
  width: 1240px;
  height: 50px;
  line-height: 50px;
  font-size: 46px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(139, 182, 68, 1);
  background: url(../../assets/img/lo.png) no-repeat 0 100%;
}
.header .common-header span {
  float: left;
  width: 100%;
  height: 26px;
  font-size: 22px;
  /* font-size: 30px; */
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
  margin-top: 20px;
}
.numClass {
  color: #8bb644;
}
.sidebar >>> .el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
}
.sidebar >>> .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}
</style>
